import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ReportPointMutationPage } from './report-point-mutation.page';

const routes: Routes = [
  {
    path: '',
    component: ReportPointMutationPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportPointMutationPageRoutingModule {}
